export const NEED_TRANS_TO_ZTMSLG_GAMES = [225, 227, 284, 474];
export const ZTMSLG_GLOBAL_GAME_ID = 191;

export const NEED_TRANS_TO_ANTSLG_GAMES = [346];
export const ANTSLG_GLOBAL_GAME_ID = 263;

export const NEED_TRANS_TO_ZROUTER_GAMES = [472];
export const ZROUTER_GLOBAL_GAME_ID = 454;

export const NEED_TRANS_TO_DTMSLG_GAMES = [354, 355];
export const DTMSLG_GLOBAL_GAME_ID = 285;

export const NEED_TRANS_TO_XDGSLG_GAMES = [466];
export const XDGSLG_GLOBAL_GAME_ID = 440;

const GAME_ID_FIELD_KEYS = ['gameId', 'game_id', 'gameID'];

export const checkNeedTranToDtmslg = gameId => {
  return NEED_TRANS_TO_DTMSLG_GAMES.includes(+gameId);
};
export const checkNeedTranToZtmslg = gameId => {
  return NEED_TRANS_TO_ZTMSLG_GAMES.includes(+gameId);
};
export const checkNeedTranToAntslg = gameId => {
  return NEED_TRANS_TO_ANTSLG_GAMES.includes(+gameId);
};
export const checkNeedTranToZrouter = gameId => {
  return NEED_TRANS_TO_ZROUTER_GAMES.includes(+gameId);
};
export const checkNeedTranToXdgslg = gameId => {
  return NEED_TRANS_TO_XDGSLG_GAMES.includes(+gameId);
};

const GAME_ID_TRANSFORM_RULES = [
  { check: checkNeedTranToZtmslg, targetGameId: ZTMSLG_GLOBAL_GAME_ID },
  { check: checkNeedTranToAntslg, targetGameId: ANTSLG_GLOBAL_GAME_ID },
  { check: checkNeedTranToZrouter, targetGameId: ZROUTER_GLOBAL_GAME_ID },
  { check: checkNeedTranToDtmslg, targetGameId: DTMSLG_GLOBAL_GAME_ID },
  { check: checkNeedTranToXdgslg, targetGameId: XDGSLG_GLOBAL_GAME_ID },
];

const applyGameIdTransform = (param, targetGameId) => {
  const result = { ...param };
  GAME_ID_FIELD_KEYS.forEach(key => {
    if (param[key] !== undefined) {
      result[key] = targetGameId;
    }
  });
  return result;
};

export const gameIdTransform = param => {
  if (Object.prototype.toString.call(param) !== '[object Object]') {
    return param;
  }
  const gameId = param.gameId || param.game_id || param.gameID;
  if (!gameId) {
    return param;
  }
  const rule = GAME_ID_TRANSFORM_RULES.find(({ check }) => check(+gameId));
  if (!rule) {
    return param;
  }
  return applyGameIdTransform(param, rule.targetGameId);
};
